export const AssetCards = {
  cards: [
    { name: 'RappiCard', installments: [6] }
  ],
  installments_text: [
    { amount: 6, value: 'Hasta 6 MSI' },
  ],
  enabled_cards_installments: [
    6
  ],
  min_price_cards_exception: {
    default_min_price_cards: 1,
    card_items_min_price: 1200,
    card_items: [0],
    card_subtitle: 'Mínimo {{card_items_min_price}}'
  }
};
